import JSEncrypt from "jsencrypt";
// import NodeRSA from "node-rsa";
const NodeRSA = require('node-rsa');

/**
 * Project Name：SRM V3.0
 * Company Name：SIE
 * Program Name：RSAUtil.js.js
 * Description: RSA非对称算法工具
 *
 * Update History
 * ==============================================================================
 * Version    Date           Updated By     Description
 * -------    -----------    -----------    ---------------
 * V1.0       2022/4/11      lizhen         创建
 * ==============================================================================
 */

class RSAUtil {

	/**
	 * @description 使用RSA加密字符串
	 * @param source
	 * @param key
	 * @returns {string | false}
	 */
	encrypt(source, key, ) {
		if (source === "" || source === null || source === undefined) {
			return null;
		}
		/*const _nodeRSA = new NodeRSA({b: 2048});
		_nodeRSA.setOptions({ encryptionScheme: 'pkcs1' })
		_nodeRSA.importKey(Buffer.from(key, 'base64'), 'pkcs8-public-der')
		let _cryptograph = _nodeRSA.encrypt(source, 'utf8', 'utf8')*/
		//return _cryptograph

		let _jsencrypt = new JSEncrypt({default_key_size: 2048})
		_jsencrypt.setKey(key)
		let _cryptograph = _jsencrypt.encrypt(source)
		return _cryptograph
	}

	/**
	 * @description 使用RSA解密字符串
	 * @param cryptograph 密文
	 * @param key
	 * @returns {string | false}
	 */
	decrypt(cryptograph, key) {
		if (cryptograph === "" || cryptograph === null || cryptograph === undefined) {
			return null;
		}
		const _nodeRSA = new NodeRSA({b: 2048});
		_nodeRSA.setOptions({ encryptionScheme: 'pkcs1' })
		_nodeRSA.importKey(Buffer.from(key, 'base64'), 'pkcs8-public-der')
		let _plaintext = _nodeRSA.decryptPublic(cryptograph, 'utf8')
		return _plaintext
	}

}

export default RSAUtil



// WEBPACK FOOTER //
// ./src/utils/RSAUtil.js